import React from 'react'

const infos = [
   { label: "Lieu", value: "IROKO FabLab – Jérico", icon: "📍" },
   { label: "Dates", value: "Du 5 au 30 août", icon: "📅" },
   { label: "Horaires", value: "Mardi, mercredi et jeudi – 14h à 17h", icon: "⏰" },
   { label: "Tarif", value: "50.000 F pour tout le programme", icon: "💵" },
   { 
     label: "Tranches d'âge", 
     value: "3 groupes: 12-15 ans, 16-18 ans et adultes", 
     icon: "👥" 
   },
   { 
     label: "Encadrement", 
     value: "1 formateur pour 8 participants maximum par groupe", 
     icon: "👨‍🏫" 
   },
]

function InfosPratiques() {
   return (
      <section className="py-20 bg-white">
         <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-title font-bold text-dark-2 text-center mb-12">📌 Infos pratiques</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
               {infos.map((info, idx) => (
                  <div
                     key={idx}
                     className="bg-light-3 rounded-xl p-6 flex items-start gap-4"
                  >
                     <span className="text-2xl">{info.icon}</span>
                     <div>
                        <h4 className="font-semibold text-dark-2">{info.label}</h4>
                        <p className="text-dark-3 text-sm md:text-base">{info.value}</p>
                     </div>
                  </div>
               ))}
            </div>
            <div className="mt-10 text-center">
               <a
                  href="https://tally.so/r/3y5Xx4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-blue-1 text-white rounded-full text-button border-2 border-blue-1
                  hover:bg-white hover:text-blue-1 transition"
               >
                  Je réserve ma place
               </a>
               <p className="text-dark-3 text-lg mt-6">📞 Contact : +229 01 xx xx xx xx</p>
               <p className="text-dark-3 text-sm mt-2">
                  Les places sont limitées à 8 participants par groupe d'âge
               </p>
            </div>
         </div>
      </section>
   )
}

export default InfosPratiques